import { normalizeLoanType } from '~/libs/loan-product-info'

export function getApprovalOption(approval, initialChange) {
  const optionId = initialChange(approval)?.optionId || null;
  let optionIndex = approval.options?.findIndex(option => option.id === optionId) || 0;
  if (optionIndex < 0) {
    optionIndex = 0;
  }
  return approval.options?.[optionIndex] ?? {};
}

export function getApprovalMaxAmount(approval, option) {
  switch (normalizeLoanType(approval?.loanProductCategoryType)) {
    case 'ach':
      return option?.maxAmount
    case 'loc':
      return option?.limits?.drawAmount?.max
    case 'term':
      return option?.limits?.amount?.max
    case 'sba':
      return option?.limits?.amount?.max
    default:
      return option?.limits?.amount?.max
  }
}

// Defaults to 'months' for any unrecognized/missing termType — callers passing a term
// stated in days/weeks must supply a matching termType, or the raw value is sent through
// as months unconverted.
export function normalizeTermType(termType) {
  switch (termType)  {
    case 'weeks':
      return 'weeks'
    case 'days':
      return 'days'
    default:
      return 'months'
  }
}

// Average weeks / days per month, matching the frequency constants used elsewhere
// Used to express a term stated in weeks or days as a number of months.
const WEEKS_PER_MONTH = 4.34524
const DAYS_PER_MONTH = 30.4167

// Convert a term into months.
export function convertTermToMonths(term, termType) {
  const value = Number(term)
  if (!Number.isFinite(value)) {
    return null
  }
  switch (normalizeTermType(termType)) {
    case 'weeks':
      return Math.ceil(value / WEEKS_PER_MONTH)
    case 'days':
      return Math.ceil(value / DAYS_PER_MONTH)
    default:
      return value
  }
}

